import React, { useEffect, useMemo, useState } from "react";
import { getContractTypes } from "common/services/contracts.service";
import { normalize } from "common/lib/normalize";

type ContractTypeFilterProps = {
  onChange: (value: any) => void;
  value: any;
  isLTA?: boolean;
};

const ContractTypeFilter = ({
  onChange,
  value,
  isLTA,
}: ContractTypeFilterProps) => {
  const [loading, setLoading] = useState(false);

  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await getContractTypes({
          pagination: {
            page: 1,
            pageSize: 10000,
          },
        });

        setData(normalize(response.data));
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [setLoading]);

  const options = useMemo(() => {
    return data.map((el: any) => {
      return {
        value: el?.id,
        label: el?.name,
      };
    });
  }, [data]);

  return (
    <select
      className="form-control"
      data-choices
      data-choices-search-false
      name="choices-single-default2"
      id="choices-single-default2"
      onChange={(e) => {
        onChange(e.target.value);
      }}
      value={value}
    >
      {loading && <option>Loading...</option>}
      <option value="">
        {isLTA ? "Select LTA Services" : "Select Contract Type"}
      </option>
      {options.map((option: any) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
};

export default ContractTypeFilter;
